import { VariableType } from 'json-to-graphql-query';
export const StatVariables = { range: 'DateRange!', format: 'String' };
export const StatVariablesWithPartnerId = { ...StatVariables, partnerId: 'Int' };
export const StatArgs = { range: new VariableType('range'), format: new VariableType('format') };
export const StatArgsWithPartnerId = { ...StatArgs, partnerId: new VariableType('partnerId') };
//# sourceMappingURL=stats.js.map